// Small accessible inline error label used across all wizard forms.
import React from 'react';

export function FieldError({ id, children }) {
  if (!children) return null;
  return (
    <div
      id={id}
      role="alert"
      className="mt-2 text-sm"
      style={{ color: 'var(--error)' }}
      data-testid={id}
    >
      {children}
    </div>
  );
}

export default FieldError;
